import { Flex, Typography } from 'antd';

import styled from '@emotion/styled';

export const Root = styled(Flex)`
`;

export const Title = styled(Typography.Title, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'isDisabled',
})<{ isActive: boolean; isDisabled?: boolean }>`
  && {
    color: ${({ isActive, isDisabled, theme }) =>
      isDisabled
        ? theme.colors.textDisabled
        : isActive
          ? theme.colors.primary
          : theme.colors.text500};
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  }
`;
